import React, { useState } from 'react';
import SearchForm from '../../containers/search/SearchForm';
import ProductsList from '../../containers/search/ProductsList';
import { SearchContext } from './context'

const Discovery = () => {
    const [queryParams, setQueryParams] = useState<any>({
        pid: [], // pids
        tg: [],  // tag
        l: [],  // label
        n: '',  // todo should use q instead?
        m: [],  // merchantIds
        b: [], // brandIds
        cids: [], // categoryIds
        oos: false, // include sold out
        nc: false,  // bypass cache
        d: false,   // show details
        newArrivals: '', // 新品,
        lowRange: '', // 价值区间
        highRange: '', // 价值区间
        s: '', // sort
        fids: [], // feature ids
    })
    const [searchResult, setSearchResult] = useState<any>(null)
    const [searchLoading, setSearchLoading] = useState(true)
    const [expandFlag, setExpandFlag] = useState(false)

    return (
        <SearchContext.Provider
            value={{
                queryParams,
                setQueryParams,
                expandFlag,
                setExpandFlag,
                searchResult,
                setSearchResult,
                setSearchLoading,
                searchLoading,
            }}
        >
            <div className='bg-light container-fluid pt-3'>
                <SearchForm />
                <ProductsList />
            </div>
        </SearchContext.Provider>
    )
}

export default Discovery
